/**
 * Utility functions for checking user permissions
 */

/**
 * Check if user can create/edit explore projects
 * @param {Object} user - User object from AuthContext
 * @returns {boolean} - True if user has editor/admin permissions
 */
export const canEditExploreProjects = (user) => {
  if (!user) return false;
  return ['editor', 'admin'].includes(user.role);
};

/**
 * Check if user can edit a specific explore project
 * @param {Object} user - User object from AuthContext
 * @param {Object} project - Project object
 * @returns {boolean} - True if user can edit this project
 */
export const canEditProject = (user, project) => {
  if (!user || !project) return false;
  
  // Owner can always edit
  if (project.ownerId === user.id) return true;
  
  // Admin can edit any project
  if (user.role === 'admin') return true;
  
  return false;
};

/**
 * Check if user can delete a specific explore project
 * @param {Object} user - User object from AuthContext
 * @param {Object} project - Project object
 * @returns {boolean} - True if user can delete this project
 */
export const canDeleteProject = (user, project) => {
  if (!user || !project) return false;
  
  // Owner can delete
  if (project.ownerId === user.id) return true;
  
  // Admin can delete any project
  if (user.role === 'admin') return true;
  
  return false;
};
